import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Scale, X, ArrowRight } from "lucide-react";
import { useCompare } from "../context/CompareContext";
import api from "../services/api";

export const CompareBar = () => {
  const { ids, remove, clear, max, notice } = useCompare();
  const [products, setProducts] = useState([]);
  const { pathname } = useLocation();

  useEffect(() => {
    if (ids.length === 0) { setProducts([]); return; }
    api.get(`/products-batch?ids=${ids.join(",")}`).then(({ data }) => setProducts(data)).catch(() => {});
  }, [ids]);

  const hidden = pathname.startsWith("/comparer") || pathname.startsWith("/admin") || pathname.startsWith("/espace-pro") || pathname.startsWith("/facture") || pathname.startsWith("/devis");
  if (hidden || (ids.length === 0 && !notice)) return null;

  return (
    <div data-testid="compare-bar" className="fixed bottom-[76px] md:bottom-4 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-2xl">
      <div className="bg-[#10131A]/95 backdrop-blur-xl border border-[#2A3040] rounded-2xl shadow-2xl shadow-black/60 px-4 py-3 flex items-center gap-3">
        <div className="flex items-center gap-2 text-slate-50 font-bold text-[13px] shrink-0"><Scale size={18} className="text-[#FF3B3B]" /> <span className="hidden sm:inline">Comparer</span> {ids.length}/{max}</div>
        <div className="flex-1 flex items-center gap-2 overflow-x-auto thin-scroll">
          {products.map((p) => (
            <div key={p.id} className="relative shrink-0 w-11 h-11 rounded-lg overflow-hidden border border-[#2A3040] bg-[#08090C]" title={p.name}>
              <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
              <button data-testid={`compare-remove-${p.id}`} onClick={() => remove(p.id)} className="absolute -top-0 -right-0 w-4 h-4 bg-[#E01F1F] text-white rounded-bl flex items-center justify-center"><X size={10} /></button>
            </div>
          ))}
          {notice && <span className="text-[12px] text-amber-300 font-semibold whitespace-nowrap">{notice}</span>}
        </div>
        <button onClick={clear} className="text-[12px] text-slate-400 hover:text-white shrink-0 hidden sm:inline">Vider</button>
        <Link to="/comparer" data-testid="compare-open" className={`btn-orange rounded-lg px-4 py-2 font-bold text-[13px] flex items-center gap-1.5 shrink-0 ${ids.length < 2 ? "opacity-50 pointer-events-none" : ""}`}>Comparer <ArrowRight size={15} /></Link>
      </div>
    </div>
  );
};

export default CompareBar;
